<template>
  <div class="d-flex">
    <span
      :class="{
        'order_status placed_status': true,
        sent_status: status == 'Sent to Restaurant',
        completed_status: status == 'Delivered',
        cancelled_status: status == 'Cancelled',
        eta_status: status && status.includes('ETA')
      }"
    >
      {{ status }}
    </span>
  </div>
</template>
<script>
export default {
  name: "OrderStatus",
  props: ["status"],
  methods: {}
};
</script>

<style lang="scss" scoped>
.order_status {
  font-size: 12px;
  padding: 10px 20px;
  border-radius: 16px;
  text-align: center;
  text-transform: capitalize;
}

@media (max-width: 767px) {
  .order_status {
    font-size: 9px;
    padding: 5px 12px;
    border-radius: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/ResOrderStatus.vue